import {Box, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  categoriesCount: number
  dataFieldsCount: number
}

export const SlaKpiTabsValuesMainHeader = ({categoriesCount, dataFieldsCount}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Box mb={2} data-test-id="tabvalues-main-header">
      <Box>
        <Typography variant="h3">{t('tabs.all')}</Typography>
      </Box>
      <Box>
        {`${categoriesCount} ${t('label.categories')}, ${dataFieldsCount} ${t(
          'label.totalDataFields'
        )}`}
      </Box>
    </Box>
  )
}
